import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/services/general.service';
import { CaisseService } from 'src/app/services/caisse.service';
import { WeatherService } from 'src/app/services/weather.service';

@Component({
  selector: 'app-open-caisse',
  templateUrl: './open-caisse.component.html',
  styleUrls: ['./open-caisse.component.scss']
})
export class OpenCaisseComponent implements OnInit {

  api = environment.apiEndPoint;
  dataSource = [];
  displayedColumns: string[] = ['Num', 'datePiece', 'client', 'raisonSociale', 'qte', 'ttc', 'dateExpiration', 'state'];

  openFormGroup: FormGroup = new FormGroup({
    'Perso_Matricule': new FormControl(),
    'Cash_Code': new FormControl(),
    'CashD_MOuverture': new FormControl(),
    'CashD_MAlimentation': new FormControl()
  });

  temperature;
  meteo;

  ds: any = {};

  constructor(
    private generalService: GeneralService,
    private router: Router,
    private caisseService: CaisseService,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private weatherService: WeatherService
  ) { }

  ngOnInit(): void {
    this.getWeather();
    let cashCode = localStorage.getItem('Cash_Code');
    if (cashCode != null) {
      this.getCashD(cashCode);
    }
  }

  getWeather() {
    let obs = this.weatherService.getSavedWeather();
    if (obs) {
      obs.add(() => {
        this.temperature = this.weatherService.temperature;
        this.meteo = this.weatherService.meteo;
      });
    }
    else {
      this.temperature = this.weatherService.temperature;
      this.meteo = this.weatherService.meteo;
    }
  }

  CaisseIsOpen(data: any[]): boolean 
  {
    let openLength = data.filter(x => x.Cash_Valide == 0).length;
    if (openLength == 1)
      return data.filter(x => x.Cash_Valide == 0).length > 0;
    else if (openLength > 1) 
    {
      throw Error('Error');
    }
    return  false
  }

  getDSCashD() {
    this.generalService.getDS('CashD')
      .subscribe((ds) => {
        Object.assign(this.ds, ds);
      });
  }

  getCashD(Cash_Code) 
  {
    this.generalService.rechercheTable('recherche/tbdata?tablere=CashD', Cash_Code).subscribe((data: any[]) => 
    {
        if (!this.CaisseIsOpen(data)) 
        {
          this.getDSCashD();
        }
        else 
        {
          let cashDOpen = data.find(x => x.Cash_Valide == 0);
          if (cashDOpen && cashDOpen.CashD_Id) 
          {
            this.setCashToCache(cashDOpen);
          }
          this.router.navigate(['/avt/caisse']);
        }
      });
  }

  doOpenCaisse() 
  {
    this.generalService.rechercheTable('recherche/tbdata?tablere=CashD', this.openFormGroup.value.Cash_Code).subscribe((data: any[]) => 
    {
      if (!this.CaisseIsOpen(data)) 
      {
        let newDS: any = {};
        newDS.CashD_Date = this.datePipe.transform(Date.now(), 'yyyy-MM-dd hh:mm:ss.SSS');
        Object.assign(newDS, this.ds.CashD[0]);
        Object.assign(newDS, this.openFormGroup.value);
        Object.assign(this.ds.CashD[0], newDS);
        this.generalService.enregisterTable(this.ds)
          .subscribe((res) => {
            this.getCashD(this.openFormGroup.value.Cash_Code);
          });
      }
      else {
        let cashDOpen = data.find(x => x.Cash_Valide == 0);
        if (cashDOpen && cashDOpen.CashD_Id) {
          this.setCashToCache(cashDOpen);
        }
        this.toastr.success("Caisse désormais ouverte");
        this.router.navigate(['/caisse']);
      }
    });
  }

  getCashCodeFromCache() 
  {
    let cash_Code = localStorage.getItem('Cash_Code');
    if (cash_Code == null) 
    {
      return false;
    }
    return false
  }
  setCashToCache(cashDOpen) {
    this.caisseService.CashD_Id = cashDOpen.CashD_Id;
    this.caisseService.Cash_Code = cashDOpen.Cash_Code;
    localStorage.setItem('CashD_Id', this.caisseService.CashD_Id);
    localStorage.setItem('Cash_Code', this.caisseService.Cash_Code);
  }
}
